<template>
    <div>
        <hos_apply_title title="转诊申请信息"></hos_apply_title>
        <el-form :model="detail" class="mt10" label-position="left" ref="docForm">
            <el-form-item label="申请医院" label-width="80px" style="margin-bottom:0px !important;">
                {{detail.initHosName}}
            </el-form-item>
            <el-form-item label="申请科室" label-width="80px" style="margin-bottom:0px !important;">
                {{detail.initDeptName}}
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="申请医生" label-width="80px" style="margin-bottom:0px !important;">
                        {{detail.initDocName}}
                    </el-form-item>
                </el-col>
                <el-col :span="10" :push="2">
                    <el-form-item label="联系电话" label-width="80px" style="margin-bottom:0px !important;">
                        {{detail.docTelphone || ''}}
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>


        <hos_apply_title title="预约转诊医院信息" class="mt10"></hos_apply_title>
        <el-form :model="detail" class="mt20" label-position="left">
            <el-form-item label="预约医院" label-width="80px" style="margin-bottom:0px !important;">
                {{detail.hopeHosName}}
            </el-form-item>
            <el-form-item label="预约科室" label-width="80px" style="margin-bottom:0px !important;">
                {{detail.hopeDeptName}}
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="预约医生" label-width="80px" style="margin-bottom:0px !important;">
                        {{detail.hopeDocName}}
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="期望预约时间" label-width="110px" prop="hopeTime" style="margin-bottom:0px !important;">
                        {{detail.hopeTime | formateTime}}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item class="flex jcc">
                <slot name="buttonGroup" class="mt60">

                </slot>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import hos_apply_title from "../../components/hos/hos-apply-title"
    export default {
        name: "apply-form-detail",
        props:{
            detail:{
                type:Object
            }
        },
        components:{hos_apply_title},
        filters:{
            formateTime(time){
                const handlerZero = (value) => {
                    return value < 10 ? '0' + value : value;
                };
                const dateObj = new Date(time);
                const Y = dateObj.getFullYear();
                const m = handlerZero(dateObj.getMonth() + 1);
                const d = handlerZero(dateObj.getDate());
                const W = dateObj.getDay();
                const H = handlerZero(dateObj.getHours());
                const M = handlerZero(dateObj.getMinutes());
                const S = handlerZero(dateObj.getSeconds());
                return Y+'-'+m+'-'+d+' '+H+':'+M
            }
        },

    }
</script>

<style lang="scss" scoped>
    @import "../../styles/hos";
</style>